<template>
  <div style="max-width: 400px;">
    <el-image v-if="showThumb === true && thumb && thumb != ''" :src="thumb" />
    <div class="d-flex bg-white p-1 justify-content-center">
      <el-image :src="fileTypeIcon(fileExt)"
                style="max-width: 40px;max-height: 40px;min-width: 40px;min-height: 40px" />
      <div class="mx-1 flex-1">
        <div
          style="word-break: break-word;
    white-space: normal;"
          class="font-size-13 fw-bold text-1-line"
        >
          {{ title }}
        </div>
        <div class="font-size-11">{{ getFileSize(fileSize) }}</div>
      </div>
      <div class="mx-1 py-1"></div>
      <div class="message-icon-download pointer">
        <el-tooltip content="Tải xuống" placement="right" effect="light">
          <el-image src="/assets/icon/ic_download.png" fit="contain" @click="downloadFile" />
        </el-tooltip>
      </div>
    </div>

    <el-progress v-if="percentage > 0" :percentage="percentage" :color="colors" class="w-100"></el-progress>
  </div>
</template>

<script>
export default {
  name: "ChatFile",
  props: {
    thumb: {
      type: String
    },
    fileExt: {
      type: String
    },
    fileSize: {
      type: String
    },
    href: {
      type: String
    },
    title: {
      type: String
    },
    showThumb: {
      default: true,
      type: Boolean
    },
    accountId: { type: String },
    messageId: { type: Object }
  },
  data() {
    return {
      colors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#6f7ad3", percentage: 100 }
      ],
      percentage: 0,
      timeInterval: null
    };
  },
  methods: {
    downloadFile() {
      if (this.percentage > 0) return;
      this.calculatePercentage();
      const msg = this.app.replaceLink.find(msg => msg.msgId == this.messageId.msgId);
      if (msg !== undefined && msg.link) {
        const fileUrl = msg.link;
        this.downSetup(fileUrl, this.title);
        return;
      }
      this.$http
        .post("/api/file", this.messageId, {
          params: { accountId: this.accountId },
          responseType: "blob"
        })
        .then(response => {
          this.percentage = 0;
          this.downSetup(response, this.title);
        })
        .catch(() => {
          this.alertError("Có lỗi xảy ra khi tải file.");
        })
        .finally(() => {
          this.percentage = 0;
        });
    },
    calculatePercentage() {
      let bytesPerSecond = 2440000;
      this.timeInterval = setInterval(() => {
        let toAddPercentage = Math.ceil((bytesPerSecond / this.fileSize) * 100);
        this.percentage += toAddPercentage;

        if (this.percentage + toAddPercentage >= 90) {
          this.percentage = 90;
          clearInterval(this.timeInterval);
        }
      }, 1000);
    },
  }
};
</script>

<style scoped></style>
